import { createContext, useContext } from 'react';
import { masterChartPath } from 'constants/masterChartRoutes';

/**
 * Kept apart from the setup page, which imports the section pages that read
 * this — one file would make those imports circular.
 */
export const MASTERCHART_SETUP_PATH = masterChartPath('setup');

export const setupStepPath = (index = 0) => `${MASTERCHART_SETUP_PATH}?step=${index}`;

/** The MasterChart subtitle, on the hub and on every setup step. */
export const MASTERCHART_INTRO =
  'Your personal health record, always up to date. Share it with any provider in seconds, and get more accurate answers from SuperIntelligence. Add as little or as much as you like.';

export const MasterChartSetupContext = createContext(null);

/**
 * `null` outside setup. Inside: `title` and `subtitle` for the page header, `footer`
 * to render under the page's content, and `onContinue(fn)` to register a save
 * that must succeed before Continue moves on. `advance()` moves on without one,
 * for an answer that settles the step by itself ("No known drug allergies").
 */
export const useMasterChartSetup = () => useContext(MasterChartSetupContext);
